import React from 'react';

const IconVideoPlay = ({ type = "play" }) => {

  if (type === "play") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="31"
        fill="none"
        viewBox="0 0 31 31"
      >
        <circle
          cx="15.5"
          cy="15.5"
          r="15.25"
          fill="#F8F8F8"
          stroke="#fff"
          strokeWidth="0.5"
        ></circle>
        <path
          fill="#19191A"
          stroke="#19191A"
          strokeWidth="0.5"
          d="M13 9.25h.43c.326 0 .646.09.922.262l7.27 4.5a1.75 1.75 0 0 1 0 2.976l-7.27 4.5a1.75 1.75 0 0 1-.921.262H13A1.75 1.75 0 0 1 11.25 20v-9c0-.966.784-1.75 1.75-1.75Z"
        ></path>
      </svg>
    );
  } else if (type === "stop") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="31"
        fill="none"
        viewBox="0 0 31 31"
      >
        <circle
          cx="15.5"
          cy="15.5"
          r="15.25"
          fill="#F8F8F8"
          stroke="#fff"
          strokeWidth="0.5"
        />

        <rect
          x="11"
          y="10.5"
          width="2.8"
          height="10"
          rx="0.8"
          fill="#19191A"
        />

        <rect
          x="17.2"
          y="10.5"
          width="2.8"
          height="10"
          rx="0.8"
          fill="#19191A"
        />
      </svg>
    );
  } else return null;

};

export default IconVideoPlay;
